/**
 * True for phones and tablets (camera-capable devices that should enter the
 * photo capture flow). Desktop and unknown devices return false so the QR
 * landing page is shown instead.
 *
 * Uses the user agent — not viewport width — so a narrow desktop window
 * still gets the QR landing (DIRES/ET open the session URL on a computer).
 *
 * Self-written on purpose: ua-parser-js 2.x is AGPL-3.0-licensed. A UA regex
 * plus a maxTouchPoints check covers every device class we care about, and a
 * misclassified device is never stranded — the QR landing page offers a
 * "Continue on this device" escape hatch (see session-entry.tsx).
 */

// iPhone|iPod — iOS phones; iPad — classic tablet UA; Android — phones and
// tablets alike; Windows Phone|IEMobile — legacy Windows phones;
// Mobi — generic mobile marker (Firefox/Opera mobile; MDN-recommended)
const MOBILE_UA_RE = /iPhone|iPod|iPad|Android|Windows Phone|IEMobile|Mobi/i;

export function isMobileDevice(
  userAgent: string = typeof navigator !== 'undefined' ? navigator.userAgent : '',
  maxTouchPoints: number = typeof navigator !== 'undefined' ? (navigator.maxTouchPoints ?? 0) : 0
): boolean {
  if (MOBILE_UA_RE.test(userAgent)) {
    return true;
  }

  // iPadOS 13+ Safari sends a desktop Macintosh UA by default ("Request
  // Desktop Website" is on for iPads). Real Macs report maxTouchPoints 0 in
  // Safari, so multi-touch on a "Macintosh" means iPad.
  return /Macintosh/i.test(userAgent) && maxTouchPoints > 1;
}
